import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {DictionaryPipe} from '../../shared/pipes/dictionary.pipe';

@Component({
  selector: 'app-pop-up-confirmation',
  templateUrl: './pop-up-confirmation.component.html',
  styleUrls: ['./pop-up-confirmation.component.scss'],
  providers: [DictionaryPipe]
})
export class PopUpConfirmationComponent implements OnInit {
  @Input() Message = '';
  @Input() Header;
  @Input() Display = false;
  @Input() confirmButton = 'OK';
  @Input() cancelButton;
  @Output() DisplayBack = new EventEmitter<boolean>();

  defaultHeaderText: string;
  result: boolean;

  constructor(private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    this.defaultHeaderText = this.dictionaryPipe.transform('MESSAGE');
  }

  close(result: boolean) {
    this.result = result;
    this.Display = false;
  }
}
